"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var BeeIcon = function BeeIcon(_ref) {
  var color = _ref.color,
    width = _ref.width,
    height = _ref.height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 14 14",
    fill: color,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.7579 4.05C11.3779 2.91 10.6179 2.15 9.47789 1.675V0.25H8.52789V1.58H8.14789C7.10289 1.58 6.24789 1.96 5.48789 2.72L5.10789 3.1L3.77789 2.625C3.49289 2.53 3.20789 2.435 2.82789 2.435C2.25789 2.435 1.68789 2.625 1.21289 3.005C0.642891 3.385 0.357891 3.86 0.167891 4.335C-0.0221094 5 -0.0221094 5.57 0.167891 6.235C0.452891 6.9 0.737891 7.375 1.21289 7.66C0.832891 9.085 1.11789 10.32 2.16289 11.365C2.92289 12.125 3.77789 12.505 4.82289 12.505C5.29789 12.505 5.58289 12.505 5.86789 12.41C6.43789 13.17 7.19789 13.645 8.14789 13.645C8.43289 13.645 8.81289 13.645 9.09789 13.55C9.66789 13.36 10.0479 12.98 10.4279 12.505C10.8079 11.935 10.9979 11.46 10.9979 10.89C10.9979 10.51 10.9979 10.225 10.9029 9.94L10.4279 8.42L10.9979 8.04C11.7579 7.28 12.1379 6.235 12.0429 5.095H13.2779V4.05H11.7579ZM2.54289 6.235C1.97289 5.95 1.78289 5.57 1.97289 5C2.16289 4.43 2.54289 4.24 3.11289 4.43L6.15289 5.57C4.63289 6.33 3.49289 6.52 2.54289 6.235ZM8.52789 11.555C7.95789 11.745 7.57789 11.555 7.29289 10.985C7.00789 10.035 7.19789 8.895 7.95789 7.375L9.09789 10.32C9.28789 10.985 9.09789 11.365 8.52789 11.555ZM9.66789 6.52L9.09789 5V4.905L8.81289 4.62H8.71789L7.19789 4.05C7.57789 3.765 7.95789 3.575 8.43289 3.575C8.90789 3.575 9.38289 3.765 9.76289 4.145C10.1429 4.525 10.3329 4.905 10.3329 5.38C10.1429 5.665 9.95289 6.14 9.66789 6.52Z"
  }));
};
BeeIcon.propTypes = _utils.iconProps;
BeeIcon.defaultProps = {
  color: '#232323',
  width: '14',
  height: '14'
};
var _default = BeeIcon;
exports.default = _default;